<template>
  <div id="cpdf">
    <div>
      <canvas class="canvasstyle" id="the-canvas"></canvas>
    </div>
  </div>
</template>

<script>
import PDFJS from "pdfjs-dist";

export default {
  name: "c-pdf",
  props: ["pdfurl"],
  data() {
    return {
      pdfDoc: null, //pdfjs 生成的对象
      pageNum: 1, //
      pageRendering: false,
      pageNumPending: null,
      scale: 0.88, //放大倍数
      page_num: 0, //当前页数
      page_count: 0, //总页数
      maxscale: 2, //最大放大倍数
      minscale: 0.6, //最小放大倍数
    };
  },
  methods: {
    renderPage(num) {
      //渲染pdf
      let vm = this;
      this.pageRendering = true;
      let canvas = document.getElementById("the-canvas");
      num = num != 0 ? num : 1;
      // Using promise to fetch the page
      this.pdfDoc.getPage(num).then(function (page) {
        let dpr = window.devicePixelRatio || 1;
        let bsr =
          vm.ctx.webkitBackingStorePixelRatio ||
          vm.ctx.mozBackingStorePixelRatio ||
          vm.ctx.msBackingStorePixelRatio ||
          vm.ctx.oBackingStorePixelRatio ||
          vm.ctx.backingStorePixelRatio ||
          1;
        let ratio = dpr / bsr;
        let viewport = page.getViewport(
          document.body.clientWidth / page.getViewport(1).width
        );
        canvas.width = viewport.width * ratio;
        canvas.height = viewport.height * ratio;
        vm.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: vm.ctx,
          viewport: viewport,
        };
        var renderTask = page.render(renderContext);
        // Wait for rendering to finish
        renderTask.promise.then(function () {
          vm.pageRendering = false;
          if (vm.pageNumPending !== null) {
            // New page rendering is pending
            vm.renderPage(vm.pageNumPending);
            vm.pageNumPending = null;
          }
        });
        if (document.getElementById("the-canvas") != null) {
          var h = Number(document.getElementById("curriculumPage_right").offsetHeight);
          var w = Number(document.getElementById("curriculumPage_right").offsetWidth);
          var content = document.getElementById("the-canvas");
          content.style.height = h - 100 + "px";
          content.style.width = w - 100 + "px";
        }
      });
      vm.page_num = vm.pageNum;
    },
    addscale() {
      //放大
      if (this.scale >= this.maxscale) {
        return;
      }
      this.scale += 0.1;
      this.queueRenderPage(this.pageNum);
    },
    minus() {
      //缩小
      if (this.scale <= this.minscale) {
        return;
      }
      this.scale -= 0.1;
      this.queueRenderPage(this.pageNum);
    },
    prev() {
      //上一页
      let vm = this;
      if (vm.pageNum <= 1) {
        return;
      }
      vm.pageNum--;
      //通知父页面页码变动
      this.$emit("page-num", {pageNum: vm.pageNum, pageCount: vm.page_count});
      vm.queueRenderPage(vm.pageNum);
    },
    next() {
      //下一页
      let vm = this;
      if (vm.pageNum >= vm.page_count) {
        return;
      }
      vm.pageNum++;
      //通知父页面页码变动
      this.$emit("page-num", {pageNum: vm.pageNum, pageCount: vm.page_count});
      vm.queueRenderPage(vm.pageNum);
    },
    jump(page) {
      let vm = this;
      if (page > vm.page_count) {
        return;
      }
      vm.pageNum = page;
      //通知父页面页码变动
      this.$emit("page-num", {pageNum: vm.pageNum, pageCount: vm.page_count});
      vm.queueRenderPage(vm.pageNum);
    },
    closepdf() {
      //关闭PDF
      this.$emit("closepdf");
      let id = document.getElementById("the-canvas");
      id.remove();
    },
    queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },
    pdfUrl(url) {
    let vm = this;
    vm.pageNum = 1;
    PDFJS.getDocument(url + "?flag=" + Math.random()).then((pdfDoc_) => {
      //初始化pdf
      vm.pdfDoc = pdfDoc_;
      vm.page_count = vm.pdfDoc.numPages;
      vm.renderPage(vm.pageNum);
      this.$emit("page-num", {pageNum: vm.pageNum, pageCount: vm.page_count});
    });
  },
  },
  computed: {
    ctx() {
      let id = document.getElementById("the-canvas");
      return id.getContext("2d");
    },
  },
  mounted() {
    let vm = this;
    console.log(`vm.pdfurl: ${vm.pdfurl}`);
    PDFJS.getDocument(vm.pdfurl + "?flag=" + Math.random()).then((pdfDoc_) => {
      //初始化pdf
      vm.pdfDoc = pdfDoc_;
      vm.page_count = vm.pdfDoc.numPages;
      vm.renderPage(vm.pageNum);
      this.$emit("page-num", {pageNum: vm.pageNum, pageCount: vm.page_count});
      this.$emit("loadPDF", true);
    }).catch(error => {
      this.$emit("loadPDF", false);
    });
  },
};
</script>


<style scoped></style>



// WEBPACK FOOTER //
// src/components/schedule/pdfjs.vue